import { Box, Typography } from "@mui/material"
import useAuth from 'hooks/useAuth';
import { useTheme } from '@mui/material/styles';



const UserName = () => {
    const theme = useTheme();
    const { user } = useAuth();

  return (
    <Box sx={{ pl:2,width:'100%' }}>
        <Typography 
            color={theme.palette.common.white} 
            variant='h5' 
            fontWeight={100}
            sx={{ textTransform: 'capitalize' }}
        >
            Hola {user?.name}
        </Typography>
    </Box>
  )
}

export default UserName